import styles from './index.css';

// Please replace, if IE11-support isn't required any longer.
//import {useFormContext} from 'react-hook-form';
import {useFormContext} from 'react-hook-form/dist/react-hook-form.ie11';

import * as React from 'react';
import {get}from 'lodash';
import classNames from 'classnames';

import Icon from '../Icon';

type TextAreaProps = {
	name: string;
	required?: boolean;
	onFocus?: () => void;
	onBlur?: () => void;
	deletable?: boolean;
	rows?: number;
    maxLength?: number;
}
export default (props: TextAreaProps) => {
	const {
		name = '',
		required = false,
		onFocus = () => {},
		onBlur = () => {},
		deletable = true,
		rows = 4,
        maxLength = props.maxLength ?? undefined,
	} = props;

	if (!name) {
		console.warn('Missing prop "name" for TextArea.');
		return null;
	}

    const [length, setLength] = React.useState<number>(0)

    const updateMaxLength = () => {
        if (props.maxLength) {
            setLength(get(getValues({nest: true}), name).length);
        }
    }

	const {register, errors, setValue, getValues} = useFormContext();
	const isInvalid = Boolean(get(errors, name));
	const hasValue = Boolean(get(getValues({nest: true}), name));
	const hasIcon = deletable && hasValue;

	return (
		<>
			<textarea
				rows={rows}
                maxLength={maxLength}
				className={classNames(
					styles.textarea,
					isInvalid && styles.isInvalid,
					hasIcon && styles.hasIcon,
				)}
                onChange={updateMaxLength}
				id={name}
				{...{name, onFocus, onBlur}}
				ref={register({required})}
			/>
			{
				hasIcon &&
					<Icon
						name="times"
						onClick={() => setValue(name, '')}
						className={styles.icon}
					/>
			}
            {
                (props.maxLength) &&
                    <div
                        className={classNames(
                            styles.maxLength,
                            (props.maxLength && (length === props.maxLength)) && styles.error
                        )}
                    >
                        {length} von {props.maxLength} Zeichen
                    </div>
            }
		</>
	);
}
